import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { Create, SimpleForm, type CreateProps } from "react-admin";

import { redirectToProjectModuleDashboard } from "@/containers/projects/redirect-to-project-module-dashboard";
import { useRouteId } from "@/utils/route-utility";

import { ProjectTakhmeenFormFields } from "./ProjectTakhmeenFormFields";
import {
  transformProjectTakhmeenCreate,
  type ProjectTakhmeenCreateFormData,
} from "./project-takhmeen-form-transforms";

export const ProjectTakhmeenCreate = (props: CreateProps) => {
  const [searchParams] = useSearchParams();
  const routeProjectId = useRouteId();
  const initialProjectId = useMemo(
    () => routeProjectId ?? searchParams.get("projectId") ?? undefined,
    [searchParams, routeProjectId]
  );
  const queryProjectId = searchParams.get("projectId");
  const redirectTo = useMemo(
    () =>
      redirectToProjectModuleDashboard({
        routeProjectId,
        queryProjectId,
        fallback: "list",
        destination: "resource-show",
      }),
    [routeProjectId, queryProjectId]
  );

  return (
    <Create
      {...props}
      redirect={redirectTo}
      transform={(data: ProjectTakhmeenCreateFormData) =>
        transformProjectTakhmeenCreate(data, { routeProjectId })
      }
    >
      <SimpleForm
        warnWhenUnsavedChanges
        sx={{ maxWidth: 720 }}
        defaultValues={{ projectId: initialProjectId, units: 1 }}
      >
        <ProjectTakhmeenFormFields routeProjectId={routeProjectId} mode="create" />
      </SimpleForm>
    </Create>
  );
};
